export default __webpack_public_path__ + "static/media/diamond-frame.aeeb0d7b.png";